import { Injectable } from '@angular/core';
import { LookupModel } from '../../common/models/LookupModel';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { LookupQueryResponseModel } from '../../common/models/LookupQueryResponseModel';

@Injectable()
export class LookupService {

  constructor(private httpClient: HttpClient) {

  }

  lookupsForEnums<TEnum>(enumType: TEnum & object): LookupModel[] {
    var lookups: LookupModel[] = [];
    for (var property in enumType) {
      if (enumType.hasOwnProperty(property)) {
        lookups.push({
          key: property,
          description: enumType[property]
        });
      }
    }
    return lookups;
  }

  lookupCompare(model1: LookupModel, model2: LookupModel): boolean {
    return model1.key === model2.key;
  }

  getLooups(category: string, termType: string, page: number, pageSize: number, sort: string, sortDirection: string, search: string, selectedCodes: string[] = null): Observable<LookupModel[]> {
    var params = new HttpParams()
      .set('skip', (page * pageSize).toString())
      .set('take', pageSize.toString())
      .set('category', category);
    if (search) {
      params = params.set('searchTerm', search);
    }
    if (sort) {
      params = params.set('sort', sort)
        .set('sortDirection', sortDirection);
    }
    if (termType) {
      params = params.set('termType', termType);
    }
    if (selectedCodes !== null && selectedCodes !== []) {
      params = params.set('selectedCodes', selectedCodes.join(','));
    }
    return this.httpClient.get<LookupQueryResponseModel>("/api/CommonModule/Lookup/Query", { params: params }).map(res => {
      var results = res.model;
      return results;
    });
  }
  //TODO: refactor to be its own service.
  getValueSets(jurisdictionalDomain: string, page: number, pageSize: number, search: string): Observable<LookupModel[]> {
    var params = new HttpParams()
      .set('page', page.toString())
      .set('take', pageSize.toString())
      .set('jurisdictionalDomain', jurisdictionalDomain);
    if (search) {
      params = params.set('searchTerm', search);
    }
    return this.httpClient.get<LookupQueryResponseModel>("/api/CommonModule/Lookup/QueryValueSets", { params: params })
      .map(res => {
        var results = res.model;
        return results;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/LookupService.ts